import React, { useMemo } from "react";
import { getDealStatusLabel } from "../../constants/filters";

const LeadsTable = ({
  leads,
  leadsVersion,
  handleRowClick,
  loading,
  hasActiveFilters,
}) => {
  // Memoize the table rows to ensure they update when leads change
  const tableRows = useMemo(() => {
    if (!leads || leads.length === 0) {
      return (
        <tr key="empty-state">
          <td colSpan="7" className="py-8 px-4 text-center text-gray-500">
            {loading
              ? "Loading leads..."
              : hasActiveFilters()
              ? "No leads match your current filters."
              : "No leads found."}
          </td>
        </tr>
      );
    }

    return leads.map((lead, index) => {
      return (
        <tr
          key={`${lead.id || index}-${leadsVersion}-${index}`}
          onClick={() => handleRowClick(lead.id)}
          className={`cursor-pointer hover:bg-gray-50 ${
            index % 2 === 0 ? "bg-white" : "bg-gray-50"
          }`}
        >
          <td className="py-3 px-4 border-b">{lead.company || "N/A"}</td>
          <td className="py-3 px-4 border-b">{lead.name || "N/A"}</td>
          <td className="py-3 px-4 border-b">{lead.email || "N/A"}</td>
          <td className="py-3 px-4 border-b">{lead.phone || "N/A"}</td>
          <td className="py-3 px-4 border-b">{lead.brandMake || "N/A"}</td>
          <td className="py-3 px-4 border-b">
            ${(lead.totalSavings || 0).toLocaleString()}
          </td>
          <td className="py-3 px-4 border-b">
            <span
              className={`px-2 py-1 rounded-full text-xs ${
                lead.dealStatus === "won" || lead.dealStatus === "closed won"
                  ? "bg-green-100 text-green-800"
                  : lead.dealStatus === "open"
                  ? "bg-blue-100 text-blue-800"
                  : lead.dealStatus === "contacted"
                  ? "bg-yellow-100 text-yellow-800"
                  : lead.dealStatus === "interested"
                  ? "bg-orange-100 text-orange-800"
                  : lead.dealStatus === "quoted"
                  ? "bg-purple-100 text-purple-800"
                  : lead.dealStatus === "lost" ||
                    lead.dealStatus === "closed lost"
                  ? "bg-red-100 text-red-800"
                  : lead.dealStatus === "no response"
                  ? "bg-gray-100 text-gray-800"
                  : "bg-blue-100 text-blue-800"
              }`}
            >
              {getDealStatusLabel(lead.dealStatus)}
            </span>
          </td>
          <td className="py-3 px-4 border-b">
            {lead.createdAt
              ? new Date(lead.createdAt).toLocaleDateString()
              : "N/A"}
          </td>
        </tr>
      );
    });
  }, [leads, leadsVersion, handleRowClick, loading, hasActiveFilters]);

  return (
    <div className="overflow-x-auto max-w-6xl mx-auto">
      <table
        key={`table-${leadsVersion}`}
        className="min-w-full bg-white rounded-lg shadow overflow-hidden"
      >
        <thead className="bg-black text-white">
          <tr>
            <th className="py-3 px-4 text-left">Company</th>
            <th className="py-3 px-4 text-left">Name</th>
            <th className="py-3 px-4 text-left">Email</th>
            <th className="py-3 px-4 text-left">Phone</th>
            <th className="py-3 px-4 text-left">Brand/Make</th>
            <th className="py-3 px-4 text-left">Total Savings</th>
            <th className="py-3 px-4 text-left">Deal Status</th>
            <th className="py-3 px-4 text-left">Created At</th>
          </tr>
        </thead>
        <tbody key={`tbody-${leadsVersion}-${leads?.length || 0}`}>
          {tableRows}
        </tbody>
      </table>
    </div>
  );
};

export default LeadsTable;
